import { render, staticRenderFns } from "./UserSearchDropdown.vue?vue&type=template&id=87c6ab56"
import script from "./UserSearchDropdown.vue?vue&type=script&lang=js"
export * from "./UserSearchDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports